import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import Presentation from './components/Presentation';
import AboutUs from './components/AboutUs';
import Methodology from './components/Methodology';
import WhatWeOffer from './components/WhatWeOffer';
import Schedule from './components/Schedule';
import WhyChooseUs from './components/WhyChooseUs';
import Gallery from './components/Gallery';
import GoogleReviews from './components/GoogleReviews';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Header from './components/Header';
import WhatsAppButton from './components/WhatsAppButton';

export default function HomePage() {
  const [isHeaderFixed, setIsHeaderFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsHeaderFixed(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header isFixed={isHeaderFixed} />
      <Hero />
      <TrustBar />
      <Presentation />
      <AboutUs />
      <Methodology />
      <WhatWeOffer />
      <Schedule />
      <WhyChooseUs />
      <Gallery />
      <GoogleReviews />
      <FAQ />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
